export enum ConfigManagerProperties {
  ImageCorpCode = 'imageCorpCode',
  DocViewWebContext = 'docViewWebContext'
}
